// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as AuthInputCmp$PorterinFeature from "../../../../login/view/components/common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonHelper.mjs";
import * as DownloadAppVMMapper$PorterinFeature from "../../../view-model/DownloadAppVMMapper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../domain/store/FareEstimateStoreV1.mjs";
import * as EditAddressDesktopInputCmp$PorterinFeature from "./EditAddressDesktopInputCmp.mjs";
import * as EditBookingDetailsModuleScss from "../../styles/EditBookingDetails.module.scss";
import * as FareEstimateResultFormHelperV1$PorterinFeature from "../../../domain/helpers/FareEstimateResultFormHelperV1.mjs";

var styles = EditBookingDetailsModuleScss;

function EditBookingDetailsDesktopCmp(Props) {
  var waypoint = Props.waypoint;
  var close_modal = Props.close_modal;
  var booking_details_form = Props.booking_details_form;
  var address_form = Props.address_form;
  var address_on_change = Props.address_on_change;
  var response = Props.response;
  return React.createElement("div", {
              className: styles["edit-booking-details-wrapper"]
            }, React.createElement("div", {
                  className: styles.close,
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: "https://nest-platform-assets.porter.in/cross_black_3f63a93cc1/cross_black_3f63a93cc1.svg",
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: "Close"
                    })), React.createElement("div", {
                  className: styles["edit-form-wrapper"]
                }, React.createElement("h1", {
                      className: styles["edit-form-title"]
                    }, "Edit " + (
                      waypoint === /* Pickup */0 ? "Pickup" : "Drop"
                    ) + " location"), React.createElement("form", {
                      className: styles["signup-form"],
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(booking_details_form.submit, undefined);
                        })
                    }, React.createElement("div", {
                          className: styles["field-wrapper"]
                        }, React.createElement(EditAddressDesktopInputCmp$PorterinFeature.make, {
                              waypoint: waypoint,
                              form: address_form,
                              address_on_change: address_on_change,
                              response: response
                            }), React.createElement("div", {
                              className: styles.spacing
                            }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: FareEstimateStoreV1$PorterinFeature.housePlaceholder,
                              is_required: false,
                              is_filled: booking_details_form.input.house_address.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    autoFocus: DownloadAppVMMapper$PorterinFeature.isIOS(undefined) ? false : true,
                                    disabled: booking_details_form.submitting,
                                    placeholder: "",
                                    type: "text",
                                    value: booking_details_form.input.house_address,
                                    onBlur: (function (param) {
                                        Curry._1(booking_details_form.blurName, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(booking_details_form.updateHouse_address, (function (input, value) {
                                                return {
                                                        house_address: value,
                                                        name: input.name,
                                                        mobile: input.mobile
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: CommonHelper$PorterinFeature.getError(booking_details_form.house_addressResult),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(booking_details_form.updateHouse_address, (function (input, param) {
                                          return {
                                                  house_address: "",
                                                  name: input.name,
                                                  mobile: input.mobile
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            }), React.createElement("div", {
                              className: styles.spacing
                            }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: FareEstimateStoreV1$PorterinFeature.namePlaceholder,
                              is_required: true,
                              is_filled: booking_details_form.input.name.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    disabled: booking_details_form.submitting,
                                    placeholder: "",
                                    type: "text",
                                    value: booking_details_form.input.name,
                                    onBlur: (function (param) {
                                        Curry._1(booking_details_form.blurName, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(booking_details_form.updateName, (function (input, value) {
                                                return {
                                                        house_address: input.house_address,
                                                        name: value,
                                                        mobile: input.mobile
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: CommonHelper$PorterinFeature.getError(booking_details_form.nameResult),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(booking_details_form.updateName, (function (input, param) {
                                          return {
                                                  house_address: input.house_address,
                                                  name: "",
                                                  mobile: input.mobile
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            }), React.createElement("div", {
                              className: styles.spacing
                            }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: FareEstimateStoreV1$PorterinFeature.mobilePlaceholder,
                              is_required: true,
                              is_filled: booking_details_form.input.mobile.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    disabled: booking_details_form.submitting,
                                    maxLength: 10,
                                    placeholder: "",
                                    type: "tel",
                                    value: booking_details_form.input.mobile,
                                    onBlur: (function (param) {
                                        Curry._1(booking_details_form.blurMobile, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(booking_details_form.updateMobile, (function (input, value) {
                                                return {
                                                        house_address: input.house_address,
                                                        name: input.name,
                                                        mobile: value
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: CommonHelper$PorterinFeature.getError(booking_details_form.mobileResult),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(booking_details_form.updateMobile, (function (input, param) {
                                          return {
                                                  house_address: input.house_address,
                                                  name: input.name,
                                                  mobile: ""
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            })))), React.createElement("div", {
                  className: styles["save-details-wrapper"]
                }, React.createElement("button", {
                      className: styles["save-details"],
                      disabled: !Curry._1(booking_details_form.valid, undefined) || booking_details_form.submitting || !Curry._1(address_form.valid, undefined) || address_form.submitting,
                      onClick: (function (param) {
                          Curry._1(booking_details_form.submit, undefined);
                        })
                    }, FareEstimateStoreV1$PorterinFeature.edit_booking_details_button), React.createElement("div", {
                      className: styles["submit-button-error"]
                    }, FareEstimateResultFormHelperV1$PorterinFeature.getFormError(response, Curry._1(booking_details_form.dirty, undefined)))));
}

var make = EditBookingDetailsDesktopCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
